import "./service_container.scss";
import ServiceBox from "../service_box/ServiceBox";

const ServiceContainer = ({ serviceInfo, index }) => {
  const service = serviceInfo;
  const serviceList = service.services;

  return (
    <div className="service_container_main" key={index}>
      <div className="service_container_header">
        <h1>{service.mainName}</h1>
      </div>
      <div
        className={`services_imgs ${
          index % 2 === 0 ? "even_service" : "odd_service"
        }`}
      >
        <div className="service_image">
          <img src={service.mainImg} alt="" />
        </div>
        <div className={`services_container container_${service.mainName} `}>
          {serviceList?.map((item, index) => (
            <ServiceBox key={index} service={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceContainer;
